import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Results Dashboard Layout Route
 * Renders Outlet to display child routes (index for /results/dashboard, $muns for /results/dashboard/:muns)
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/results/dashboard')({
  component: () => <Outlet />,
});
